<form class="mt-6 space-y-4" (submit)="submit(); $event.preventDefault()">
  @if (showCurrentPassword) {
    <div>
      <label for="currentPassword" class="text-sm font-semibold text-slate-700">
        Old password
      </label>
      <input
        id="currentPassword"
        type="password"
        autocomplete="current-password"
        [value]="form.currentPassword"
        (input)="form.currentPassword = $any($event.target).value"
        class="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm outline-none transition-colors focus:border-secondary focus:ring-2 focus:ring-secondary/20"
      />

      @if (submitted && !form.currentPassword) {
        <p class="mt-1 text-sm text-red-600">Old password is required.</p>
      }

      @if (currentPasswordTooShort) {
        <p class="mt-1 text-sm text-red-600">Password must be at least 8 characters long.</p>
      }
    </div>
  }

  <div>
    <label for="newPassword" class="text-sm font-semibold text-slate-700"> New password </label>
    <input
      id="newPassword"
      type="password"
      autocomplete="new-password"
      [value]="form.newPassword"
      (input)="form.newPassword = $any($event.target).value"
      class="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm outline-none transition-colors focus:border-secondary focus:ring-2 focus:ring-secondary/20"
    />

    @if (submitted && !form.newPassword) {
      <p class="mt-1 text-sm text-red-600">Password is required.</p>
    }

    @if (newPasswordTooShort) {
      <p class="mt-1 text-sm text-red-600">Password must be at least 8 characters long.</p>
    }
  </div>

  <div>
    <label for="confirmNewPassword" class="text-sm font-semibold text-slate-700">
      Repeat new password
    </label>
    <input
      id="confirmNewPassword"
      type="password"
      autocomplete="new-password"
      [value]="form.confirmNewPassword"
      (input)="form.confirmNewPassword = $any($event.target).value"
      [class.border-red-300]="newPasswordsDoNotMatch"
      [class.focus:border-red-500]="newPasswordsDoNotMatch"
      [class.focus:ring-red-200]="newPasswordsDoNotMatch"
      class="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm outline-none transition-colors focus:border-secondary focus:ring-2 focus:ring-secondary/20"
    />

    @if (submitted && !form.confirmNewPassword) {
      <p class="mt-1 text-sm text-red-600">Please repeat your new password.</p>
    }

    @if (newPasswordsDoNotMatch) {
      <p class="mt-2 text-sm font-medium text-red-600">The new passwords do not match.</p>
    }
  </div>

  @if (error) {
    <div class="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
      {{ error }}
    </div>
  }

  @if (success) {
    <div class="rounded-lg border border-green-200 bg-green-50 px-3 py-2 text-sm text-green-700">
      {{ success }}
    </div>
  }

  <div class="flex justify-end gap-2 pt-2">
    <button
      type="button"
      (click)="cancel()"
      class="rounded-lg border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 transition-colors hover:bg-slate-50"
    >
      {{ cancelLabel }}
    </button>

    <button
      type="submit"
      [disabled]="formInvalid || loading"
      class="rounded-lg bg-secondary px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-hover disabled:cursor-not-allowed disabled:opacity-50"
    >
      {{ loading ? loadingLabel : submitLabel }}
    </button>
  </div>
</form>
